import humps from 'humps'
import {find, isEmpty} from 'lodash'

import api from '@/lib/api'
import helper from '@/lib/helper'

export default {
  namespaced: true,

  state: {
    testId: null,
    eventId: null,

    dbRequest: null,
    dbUser: null,
    reviewing: false,

    statuses: [
      {id: '01', text: 'Pending', state: 'Pending'},
      {id: '02', text: 'Reject', state: 'Rejected'},
      {id: '03', text: 'Approve', state: 'Approved'},
      {id: '04', text: 'Subscribe', state: 'Subscribed'},
    ],
//    ndaStates: ['N/A', 'Active', 'Inactive', 'Expired'],
//    ndaStates: ['N/A', 'Active', 'Pending', 'Inactive', 'Expired'],
    ndaStates: [
        {
            "text": "Active",
            "value": "AC",
        }, {
            "text": "Created",
            "value": "CR",
        }, {
            "text": "Pending",
            "value": "PD",
        }, {
            "text": "Canceled",
            "value": "CA",
        }, {
            "text": "Expired",
            "value": "EX",
        }, {
            "text": "N/A",
            "value": "NA",
        }
    ],
    keypass: null,
  },
  getters: {
    events: (s, g, rs) => {
      const id = s.testId
      const t = find(rs.tests, (x) => x.id == id)

      if (!t) return []

      const a = []
      for (const o of t.events) {
        if (!o.closed || (s.dbRequest && s.dbRequest.event.id == o.id)) {
          a.push({value: o.id, text: o.name, closed: o.closed})
        }
      }
      // reverse simcenter event list for now -- remove later
      if (id == '20') {
        a.reverse()
      }
      return a
    },
    event: (s, g, rs, rg) => {
      const id = s.eventId
      const ev = find(rg.events, (x) => x.id == id)

      return ev || null
    },
  },
  mutations: {
    testId: (s, v) => (s.testId = v),
    eventId: (s, v) => (s.eventId = v),

    dbUser: (s, o) => (s.dbUser = isEmpty(o) ? null : humps.camelizeKeys(o)),
    dbRequest: (s, o) => (s.dbRequest = isEmpty(o) ? null : humps.camelizeKeys(o)),
    reviewing: (s, b) => (s.reviewing = b),
    keypass: (s, o) => (s.keypass = isEmpty(o) ? null : humps.camelizeKeys(o)),

    reset: (s) => {
      s.testId = null
      s.eventId = null

      s.dbUser = null
      s.dbRequest = null
      s.reviewing = false
      s.keypass = null
    },
  },
  actions: {
    async onEnter({commit}, p) {
      commit('testId', p.testId)
      commit('eventId', p.eventId)
      commit('toa/reset', null, {root: true})
    },
    async decodeToken({commit}, p) {
      try {
        const resp = await api.event.token.decode(p.eventId, p.token)
        if (resp.data.valid) {
          commit('keypass', {
            eventId: resp.data.event_id,
            testId: resp.data.test_id,
          })
        }
      } catch (e) {
        commit('keypass', null)
      }
    },
    async fetchRequest({commit, state, getters, rootState}, to) {
      const ps = to.params
      const qs = to.query

      try {
        if (ps.eventId && qs.id && helper.admin()) {
          const resp = await api.request.get({request_id: qs.id})

          if (resp.data.event.id != ps.eventId) {
            throw new Error()
          }
          commit('dbRequest', resp.data)
          commit('reviewing', true)
        } else if (ps.eventId && rootState.webkey.id) {
          const webkey_id = rootState.webkey.id
          const event_id = ps.eventId

          const resp = await api.request.get({webkey_id, event_id})
          commit('dbRequest', resp.data)
          commit('reviewing', false)
        }

        if ((state.dbRequest && getters.event.test.mode == 'FTG') || getters.event.test.mode == 'PRT') {
          const o = {
            eventId: state.dbRequest.event.id,
            testId: state.dbRequest.event.test.id,
          }
          commit('keypass', o)
        }
      } catch (e) {
        commit('dbRequest', null)
        commit('reviewing', false)
      }
    },
  },
}
